import {
    SPI,
    ActionType,
    BaseActionWidget,
    ViewType,
    Widget
} from '@kunlun/dependencies';
import BatchUpdateSpecialItem from './BatchUpdateSpecialItem.vue'
import {ServerActionWidget} from "@kunlun/vue-admin-base/src/action/server-actions";

@SPI.ClassFactory(
    BaseActionWidget.Token({
        viewType: ViewType.Table,
        actionType: ActionType.Client,
        name: '$$internal_BatchUpdate',
        model: "deli.aries.trade.DeliAriesSpecialApplyOrderItem",
        widget: 'ClientAction',
    })
)
export class batchUpdateSpecialItem extends ServerActionWidget {
    initialize(props: any) {
        super.initialize(props);
        this.setComponent(BatchUpdateSpecialItem)
        return this;
    }

    @Widget.Reactive()
    protected get selectRecords() {
        return this.parentActiveRecords;
    }

    @Widget.Method()
    setRootTableData(data) {
        // const newArr : any[] = [...data , ...(this.dataSource || [])];
        // const uniqueArr: any[] = [];
        // const uniqueMap: any = {};
        //
        // console.log(this)
        // console.log(newArr)
        // // 去重
        // newArr.forEach((i, index) => {
        //     i._sortIndex = index;
        //     uniqueMap[i.skuId] = i;
        // });
        // // 转数组
        // for (let k in uniqueMap) {
        //     uniqueArr.push(uniqueMap[k]);
        // }
        // // 排序
        // uniqueArr.sort((a, b) => a._sortIndex - b._sortIndex);
        // console.log(uniqueArr)
        // this.reloadDataSource(uniqueArr);
    }
}
